import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import * as API from "../services/pacientes";

export function PacienteAdminList(props) {
  const [pacienteList, setPacienteList] = useState();
  const [pacienteQuery, setPacienteQuery] = useState("");
  console.log(props)

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (props.userRole.includes('administrador') || props.userRole.includes('psicologia-hospital') || props.userRole.includes('medicina')) {
          await API.getSearchPacientes(pacienteQuery).then(
            (val) => {
              setPacienteList(val);
            },
            (error) => {
              console.log(error);
            }
          );
        } else {
          await API.getSearchPacientesByEspecialista(pacienteQuery, props.especialistaId).then(
            (val) => {
              setPacienteList(val);
            },
            (error) => {
              console.log(error);
            }
          );
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [pacienteQuery]);
  return (
    <>
      <div id='content'>
        <div id='formNewElement'>
          <div className='field'>
            <label htmlFor='pacienteQuery'>Buscar Paciente</label>

            <div className='control'>
              <input
                className='input'
                id='pacienteQuery'
                required
                type='text'
                value={pacienteQuery}
                onChange={(e) => setPacienteQuery(e.target.value)}
              />
            </div>
          </div>

          {pacienteList?.length ? (
            <ul>
              {console.log(pacienteList)}
              {pacienteList?.map((paciente) => (
                <li key={paciente.id}>
                  <Link to={`${paciente.id}`}>
                    {paciente.display_name}
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p>
              <i>Sin pacientes</i>
            </p>
          )}
        </div>
      </div>
      <div id='actions'>
        {
          <Link className='button is-link' to={`new`}>
            Nuevo
          </Link>
        }
      </div>
    </>
  );
}
